/* eslint-disable react/no-unescaped-entities */
import { Button } from '@/components/ui/button';
import { ScrollArea } from '@/components/ui/scroll-area';
import { useAppSearchParams } from '@/hooks/use-app-search-params';
import DOMPurify from 'dompurify';

const PrivacyPolicy = (props: { policy: string, workspaceName: string }) => {
  const { policy, workspaceName } = props;
  const params = useAppSearchParams();

  function onSubmit() {
    params.set({ view: 'company-info' });
  }
  // Sanitize the HTML content
  const cleanHtml = DOMPurify.sanitize(policy, {
    USE_PROFILES: { html: true },
    ALLOWED_TAGS: [
      'h1',
      'h2',
      'h3',
      'h4',
      'h5',
      'h6',
      'p',
      'br',
      'strong',
      'em',
      'a',
      'ul',
      'ol',
      'li',
      'table',
      'thead',
      'tbody',
      'tr',
      'th',
      'td'
    ],
    ALLOWED_ATTR: ['href', 'target', 'rel', 'class']
  });

  const createMarkup = () => {
    return { __html: cleanHtml };
  };
  return (
    <div className='flex w-full flex-col bg-white p-6 md:p-10'>
      <div className='mx-auto w-full max-w-xl lg:max-w-2xl'>
        <h2 className='mb-2 text-2xl font-bold capitalize md:text-3xl'>
          {workspaceName || ''} Privacy Policy
        </h2>
        <p className='mb-6 text-gray-700'>
          Kindly accept the terms and condition to continue
        </p>

        <ScrollArea className='h-[400px] rounded-md border p-5 md:h-[500px] xl:h-[600px]'>
          <div
            className='tw-text-main manrope lg:tw-text-xl tw-text-base tw-font-normal tw-leading-8 text-justify'
            dangerouslySetInnerHTML={createMarkup()}
          />
        </ScrollArea>

        <div className='mt-6'>
          <Button
            onClick={onSubmit}
            className='w-full bg-[#1e3380] text-white hover:bg-[#152661]'
          >
            I Agree
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
